// Dependencies
import { useState, useRef, useEffect, useContext } from 'react';
import _ from 'lodash'; 
import _cx from 'classnames'; 

// Components 
import Tooltip from '../Tooltip';
import { FormField, } from './Fields';
import { DropdownSelect } from './DropdownSelect';
import { OptionSelect, OptionField } from './OptionSelect';

// Types 
import { Types, Components } from '../../utils/types';

// Contexts
import AppContext from '../../contexts/AppContext';

// Utils
import {  } from '../../utils/config'
import { getOptionIcon } from '../../utils/helpers'
import { CSSTransition } from 'react-transition-group';
 
const FormGroup = ({name, label, tooltipLabel, autoScroll = true, isCurrent, type, options, hasIcons, min, max, suffix, source, autocomplete, placeholder}: Components.FormGroup) => {
    
    const formGroupRef = useRef<any>(null);
    const { refs, isScrollable } = useContext(AppContext);
    const [isMounted, setIsMounted] = useState<boolean>(false);

    // Scroll into view
    useEffect(() => {
        
        // TODO: Context >> Prev selected field, current field ref :)
        requestAnimationFrame(() => {
            setIsMounted(true);
        })

        // Prevent unnecessary scrolling on form open
        if ( ! isScrollable ) {
            return;
        }

        if ( type === 'dropdown' ) {
            setTimeout(() => {
                formGroupRef?.current.scrollIntoView({block: "start", behavior: "smooth", inline: "nearest"});
            }, 50)
        }

        setTimeout(() => {
            refs.prevField = refs.currentField;
            refs.currentField = formGroupRef;
            
            if ( refs.prevField.current?.classList.contains('radio' ) || refs.prevField.current?.classList.contains('dropdown' ) )  {
                if ( autoScroll ) {
                    formGroupRef.current?.scrollIntoView({block: "start", behavior: "smooth", inline: "nearest"}); // TODO:    More precise scrollIntoView (custom with offset)
                }
            }
        }, 50);

    }, [])
    
    return (
        <div ref={formGroupRef} className={_cx('form-group', type, {'is-visible': isMounted, 'has-tooltip': tooltipLabel})} data-name={name}>
            
            <label className="form-group__label">
                <span>{label}</span>
            </label> 

            {
                (['checkbox', 'radio'].includes(type) && options ) && 
                    <div className="form-group__options">
                        <OptionSelect hasIcons={hasIcons} {...{name, type, options}} />
                    </div>
            }
            
            { 
                (['dropdown'].includes(type) && options ) && 
                    <div className="form-group__options">
                        <DropdownSelect hasIcons={hasIcons} {...{name, type, autocomplete, options, placeholder, source}} />
                    </div>
            }

            {
                (['text', 'number', 'email', 'tel', 'timerange'].includes(type) ) && 
                <div className="form-group__field"> 
                    <FormField {...{name, type, suffix, min, max, placeholder}} />
                </div>  
            }

            {tooltipLabel && options && 
                <Tooltip className="form-group__tooltip" label={tooltipLabel}>
                    <>
                    <div className="modal__items">
                        {options.map( (option: Types.FormOption, index: number) => (
                            <div className="modal-item" key={index}>
                                <div className="modal-item__header">
                                <div 
                                    className="modal-item__icon"
                                    style={!_.isEmpty(option.color) ? {backgroundColor: option.color} : {}}     
                                >
                                    <img src={ getOptionIcon(option)} alt={`${name}-icon`} />
                                </div>                                    
                                    <h2 className="modal-item__heading">{option?.label}</h2>
                                </div>
                                {option?.description &&
                                    <div className="modal-item__description">
                                        {option?.description.split("\\n").map((str, i) => <p key={i}>{str}</p>)}
                                    </div>
                                }
                            </div>
                        ))}
                        </div>
                    </>
                </Tooltip>
            }
        </div>
    ) 
}

export default FormGroup; 